import React, { useEffect, useRef, useState } from "react";

const OtpInput = ({ values, onChange, handleParentChange }) => {
  const inputRefs = useRef([]);

  const handleInputChange = (e, index) => {
    e.preventDefault();
    const newValues = [...values];
    newValues[index] = e.target.value.slice(-1); 
    onChange(newValues);

    if (e.target.value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !values[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    const firstEmptyIndex = values.findIndex((val) => val === "-" || val === "");
    if (firstEmptyIndex !== -1 && inputRefs.current[firstEmptyIndex]) {
      inputRefs.current[firstEmptyIndex].focus();
    }
  }, [values]);

  return (
    <div className="flex justify-center" style={{ gap: "20px" }}>
      {values.map((value, index) => (
        <input
          key={index}
          type="tel"
          maxLength={1}
          value={value}
          onChange={(e) => handleInputChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputRefs.current[index] = el)}
          placeholder="-"
          className="otp-input text-center font-bold text-26x rounded focus:outline-none border border-brand-base-primary text-brand-base-primary rounded-16x"
          style={{
            width: "60px",
            height: "60px",
            backgroundColor: "var(--light-brand-base-primary)",
          }}
        />
      ))}
    </div>
  );
};

const VerificationInput = ({ 
  id,
  value,
  handleChange,
 }) => {
  const [code, setCode] = useState(["", "", "", ""]);

  const handleCodeChange = (newValues) => {
    setCode(newValues);
    handleChange(newValues.join(""));
  };

  return (
    <OtpInput
      values={code}
      onChange={handleCodeChange}
      handleParentChange={handleChange}
    />
  );
};

export default VerificationInput;
